import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { AttachmentsSettings, EmailSettings, PrintingsSettings } from './document-send-email-settings';
import { DocumentSendEmailCommandResult } from './document-send-email-single.command-base';


export type DocumentSendEmailMultiCommandParams = DocumentBatch[];

type DocumentBatch = {
    documents: ({ id: number; } & PrintingsSettings)[];
    emailSettings: EmailSettings;
    attachmentsSettings: AttachmentsSettings;
};

export class DocumentSendEmailMultiCommand extends Command<DocumentSendEmailMultiCommandParams, void> { }

export class DocumentSendEmailMultiCommandHandlerBase implements CommandHandler<DocumentSendEmailMultiCommand, DocumentSendEmailMultiCommandParams, void> {
    private static Url = TaggedUrl.join('documents/batch/emailQueue', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync({ params }: DocumentSendEmailMultiCommand): Promise<void> {
        await this.http.post<DocumentSendEmailCommandResult>(DocumentSendEmailMultiCommandHandlerBase.Url, params, { timeout: MS_PER_MINUTE });
    }
}
